import React from 'react';
import PropTypes from 'prop-types';

function SideBySide({ bgColorClass = 'bg-slate', reverse, slot1, slot2 }) {
  return (
    <article
      className={`px-4 py-12 text-white md:py-16 sm:px-6 lg:px-8 ${bgColorClass}`}
    >
      <div className="grid items-center justify-center w-full max-w-3xl gap-8 mx-auto lg:max-w-4xl md:grid-cols-2">
        <div>{slot1}</div>
        <div
          className={`flex justify-center ${
            reverse ? 'md:order-first md:justify-start' : 'md:justify-end'
          }`}
        >
          {slot2}
        </div>
      </div>
    </article>
  );
}

SideBySide.propTypes = {
  bgColorClass: PropTypes.string,
  reverse: PropTypes.bool,
  slot1: PropTypes.node.isRequired,
  slot2: PropTypes.node.isRequired,
};

export { SideBySide };
